import 'vanilla-cookieconsent'
import { getConfig } from './config'
import { CookieConsentCustomSettings } from '../types/sdk'

class CookieBanner {
  private bannerAPI: CookieConsent | undefined

  init(params?: CookieConsentCustomSettings) {
    if (this.bannerAPI) {
      return
    }
    const config = getConfig()
    this.bannerAPI = window.initCookieConsent()
    this.bannerAPI.run({
      ...config,
      onFirstAction: (...args) => {
        config?.onFirstAction?.(...args)
        try {
          params?.onFirstConsent?.(...args)
        } catch (error) {
          console.warn('onFirstConsent callback failed: ', error)
        }
      },
      onAccept: (...args) => {
        config?.onAccept?.(...args)
        //! TODO - allow users to pass in a callback for this
      },
      onChange: (...args) => {
        config?.onChange?.(...args)
        try {
          params?.onConsentChange?.(...args)
        } catch (error) {
          console.warn('onChange callback failed: ', error)
        }
      },
    })
  }

  showSettings() {
    this.bannerAPI?.showSettings(0)
  }
}

const cookieBanner = new CookieBanner()

export default cookieBanner
